import { formatDateToRssFeed } from '@mais-retorno-front/helpers/date';
import { formatContentToFeeds } from '@mais-retorno-front/helpers/format';
import { getVideoThumbFromYoutube } from '@mais-retorno-front/helpers/video-thumb';
import { IFeeds } from '@mais-retorno-front/models/feed.model';
import { AxiosInstance } from 'axios';

interface IResponse {
  data: {
    videos: {
      data: {
        attributes: {
          title: string;
          slug: string;
          publishedAt: string;
          content: string;
          updatedAt: string;
          excerpt: string;
          path: string;
          video_id: string;
        };
      }[];
    };
  };
}

export class GetVideosFeedUseCase {
  constructor(private readonly http: AxiosInstance) {}

  async execute(page: number): Promise<IFeeds[]> {
    const { data } = await this.http.post<IResponse>('', {
      query: `
        query videos {
          videos(
            sort: "publishedAt:desc"
            pagination: { page: ${page}, pageSize: 1000 }
          ) {
            data {
              attributes {
                title
                slug
                publishedAt
                content
                updatedAt
                excerpt
                path
                video_id
              }
            }
          }
        }
      `,
    });

    const videos = data?.data?.videos?.data;

    if (!videos || videos.length === 0) {
      return null;
    }

    return videos.map(({ attributes }) => {
      return {
        title: attributes?.title,
        publishedAt: formatDateToRssFeed(attributes?.publishedAt),
        content: formatContentToFeeds(attributes?.content),
        updatedAt: formatDateToRssFeed(attributes?.updatedAt),
        url: `${process.env.NEXT_PUBLIC_DOMAIN}${attributes?.path}/${attributes?.slug}`,
        author: null,
        contentCategories: ['videos'],
        thumbnail: {
          url: getVideoThumbFromYoutube(attributes?.video_id) || '/img/placeholder.png',
        },
      };
    });
  }
}
